//import { post, put } from "axios";
import axios from 'axios';
import { getApiAsyn, baseUrl, getApiAsynarrayBuffer, deleteApi2, postApiAsynArrayBuffer, getAuthHeaders } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import { extractData } from "../../../../utils";
import { getDecoratedUrl } from "../../../common/urlService";



const { post, put, get } = axios;
export const fetchVehicleVehicleOperations = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.VEHICLE_VEHICLEOPERATIONS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchVehicleOperationDropdown = async (payload) => {
  const url = API_URL.VEHICLE_VEHICLEOPERATIONS.MODELDROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
export const fetchCategory = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.VEHICLE_VEHICLEOPERATIONS.GETCATEGORY,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};



export const multipartDataUploadImage = (url, payload) => {
 
  const formPayload = new FormData();
  formPayload.append("file", payload?.file[0]);
  const config = {
    headers: {
      ...getAuthHeaders(localStorage.getItem("token")),
      "Content-Type": "multipart/form-data",
    },
  };
  return post(baseUrl + url, formPayload, config);
};



export const upladImageData = async (payload) => {
  const url = API_URL.UPLOAD_IMAGE.replace(
    ":id",
    payload.id
  );
  try {
    let result = await multipartDataUploadImage(
      url,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return post(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
export const createVehicleVehicleOperations = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.VEHICLE_VEHICLEOPERATIONS.CREATE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editVehicleVehicleOperations = async (payload) => {
  const url = API_URL.VEHICLE_VEHICLEOPERATIONS.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};





const dataExportApi = (url, data) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };
    return get(baseUrl + url, data, config);
};

export const exportVehicleVehicleOperationsRecord = async (payload) => {
  const url = API_URL.VEHICLE_VEHICLEOPERATIONS.EXPORT;
  const requestBody = {
    pageNumber: payload?.pageNumber ?? 0,
    pageSize: payload?.pageSize,
    paged: payload?.paged ?? false,
    sort: payload?.sort || "id,desc",
    userId: Number(localStorage.getItem("userId")),
  };
  try {
    let result = await postApiAsynArrayBuffer(url, requestBody, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};




export const fetchVehicleVehicleOperationsById = async (payload) => {
  const url = API_URL.VEHICLE_VEHICLEOPERATIONS.GET_BY_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteVehicleVehicleOperations = async (payload) => {
  const url = API_URL.VEHICLE_VEHICLEOPERATIONS.DELETE
    .replace(":id", payload?.id)
    .replace(":userId", localStorage.getItem("userId"));
  try {
    let result = await deleteApi2(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

/** Triggers browser download of the blank import template (.xls) */
export const downloadVehicleImportTemplate = async () => {
  const userId = localStorage.getItem("userId");
  const url = `${baseUrl}${API_URL.VEHICLE_VEHICLEOPERATIONS.IMPORT_TEMPLATE}?userId=${userId}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: { authorization: localStorage.getItem("token") },
    });
    if (!response.ok) throw new Error("Template download failed");
    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = "Vehicle_Import_Template.xls";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(objectUrl);
    return { isError: false };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

/** Uploads a filled Excel file; returns JSON with totalRows/successCount/failedCount/errors */
export const importVehicleVehicleOperations = async (payload) => {
  const formPayload = new FormData();
  formPayload.append("file", payload.file);
  formPayload.append("userId", localStorage.getItem("userId"));

  // No Content-Type header — browser sets multipart boundary automatically
  const config = {
    headers: { authorization: localStorage.getItem("token") },
  };

  try {
    const result = await post(
      baseUrl + API_URL.VEHICLE_VEHICLEOPERATIONS.IMPORT,
      formPayload,
      config
    );
    if (result?.data?.error) throw new APIError(result.data);
    return result.data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
